import { axiosInstance } from 'utils/AxiosInstance';
import { API_PATHS } from 'utils/constants';
import strategyClient from 'utils/storage/strategyClient';
import { clientConfig } from 'utils/utils';
import {
  IAdminTopUp,
  IInviteUser,
  IOrganizationUpdate,
  Order,
} from './../utils/contracts';

export const updateOrganization = async (orgUpdate: IOrganizationUpdate) => {
  if (orgUpdate.preview) {
    const uploaderService = strategyClient.getStrategy(
      'image',
      orgUpdate.id,
      5000
    );
    const path =
      clientConfig.cloudinaryFolder + '/organizations/' + orgUpdate.id + '/cover';

    let file = await uploaderService.uploadObject({
      publicId: path,
      id: orgUpdate.id,
      type: 'image',
      file: orgUpdate.preview,
      destination: path,
      size: { height: 280, width: 280 },
    } as any);
    orgUpdate.image_url = file.webContentLink;
  }

  return await axiosInstance.put(
    `${API_PATHS.UPDATE_BUSINESS_SETTINGS}${orgUpdate.id}`,
    {...orgUpdate,preview:orgUpdate.image_url}
  );
};

export const updateBusinessSetting = async (orgUpdate: IOrganizationUpdate) => {
  if (orgUpdate.preview) {
    const uploaderService = strategyClient.getStrategy(
      'image',
      orgUpdate.id,
      5000
    );
    const path =
      clientConfig.cloudinaryFolder + '/organizations/' + orgUpdate.id + '/cover';

    let file = await uploaderService.uploadObject({
      publicId: path,
      id: orgUpdate.id,
      type: 'image',
      file: orgUpdate.preview,
      destination: path,
      size: { height: 280, width: 280 },
    } as any);
    orgUpdate.image_url = file.webContentLink;
  }
  return await axiosInstance.put(
    `${API_PATHS.UPDATE_BUSINESS_SETTINGS}${orgUpdate.id}/business-setting`,
    {...orgUpdate,preview:orgUpdate.image_url}
  );
};


export const inviteMember = async (data: IInviteUser) => {
  return await axiosInstance.post(
    `${API_PATHS.INVITE_MEMBER_BUSINESS_SETTINGS}`,
    data
  );
};

export const resendInvitation = async (invitationId: any) => {
  return await axiosInstance.patch(`/invites/${invitationId}/resend`);
};

export const removeStaffbyInvitationID = async (invitationId: any) => {
  return await axiosInstance.delete(`/users/${invitationId}/kick`);
};



export const cancelInvitation = async (invitationId: any, organizationId: any) => {
  return await axiosInstance.delete(`/invites/${invitationId}`,
    {
      headers: {
        'x-organization-id': organizationId,
      },
    }
  );
};

export const adminCancelInvitation = async (invitationId: any,organizationId: any) => {
  return await axiosInstance.delete(`/invites/${invitationId}`,{
    headers: {
      'x-organization-id': organizationId,
    },
  });
};

export const addOrganization = async (orgUpdate: any) => {
  if (orgUpdate.preview) {
    const uploaderService = strategyClient.getStrategy(
      'image',
      orgUpdate.id,
      5000
    );
    const path =
     clientConfig.cloudinaryFolder + '/organizations/' + orgUpdate.id + '/cover';

    let file = await uploaderService.uploadObject({
      publicId: path,
      id: orgUpdate.id,
      type: 'image',
      file: orgUpdate.preview,
      destination: path,
      size: { height: 280, width: 280 },
    } as any);
    orgUpdate.image_url = file.webContentLink;
  }

  return await axiosInstance.post(`${API_PATHS.ADMIN_ADD_BUSINESS}`, orgUpdate);
};

export const adminTopUp = async (topupData: IAdminTopUp) => {
  return await axiosInstance.post(`${API_PATHS.ADMIN_TOP_UP}`, topupData, {
    headers: {
      'x-organization-id': topupData.OrganizationId ?? '',
    },
  });
};

export const updatePermission = async (
    userId: string,
    authorization: string,
    organizationId: string
) => {
    return await axiosInstance.put(
        `${API_PATHS.UPDATE_USER_PERMISSION}`,
        {
            userId,
            authorization,
            organizationId,
        }
    )
}

interface TransactionsQueryParams {
  page: number;
  pageSize: number;
  sortOrder: Order;
  sortBy: string;
  /** Substring match on revision_id */
  searchRevision?: string;
  /** Exact match on transaction project_id (Mongo id string) */
  projectId?: string;
}

export const getOrganizationTransactions = async (organizationId: string, query: TransactionsQueryParams) => {
  const response = await axiosInstance.post(`organizations/${organizationId}/transactions`, query);
  return response.data;
};

export const getOrganizationById = async (organizationId: string) => {
  const response = await axiosInstance.get(`organizations/${organizationId}`);
  return response.data;
};

export const cancelTransaction = async (organizationId: string, transactionId: string, reason?: string) => {
  return await axiosInstance.patch(
    `/admin/organizations/${organizationId}/transactions/${transactionId}/cancel`,
    { reason: reason || undefined }
  );
};
